import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { addManufactureOrSubType } from "../api/addManufactureOrSubType";

export const useAddManufactureOrSubType = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (body) => addManufactureOrSubType(body),
    onSuccess: () => {
      toast.success("Saved successfully.");
      queryClient.invalidateQueries({ queryKey: ["materialOptions"] });
      queryClient.invalidateQueries({ queryKey: ["syncStatus"] });
      queryClient.invalidateQueries({ queryKey: ["pendingChanges", "material"] });
    },
    onError: () => {
      toast.error("Failed to save. Please try again.");
    },
  });
};

